import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children, allowedRoles }) {
  const { userInfo } = useSelector((state) => state.user);
 
  
  

  if (!userInfo) {
    return <Navigate to="/login" />;
  }

  if (!allowedRoles.includes(userInfo.userType)) {
    return <Navigate to="/login" />;
  }

  return children;
}
